/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type GetPatientConversationQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>
  order?: Types.InputMaybe<Types.FeedOrder>
  before?: Types.InputMaybe<Types.Scalars['DateTime']['input']>
  after?: Types.InputMaybe<Types.Scalars['DateTime']['input']>
}>

export type GetPatientConversationQuery = {
  __typename?: 'Query'
  feed: {
    __typename?: 'FeedSuccess'
    lastSeenAt?: Date | null
    items: Array<
      | {
          __typename: 'ChatMessage'
          messageID: string
          feedID: string
          createdAt: Date
          text: string
          coachID?: string | null
          itemID: string
          chatMessageDirection: Types.ChatMessageDirection
          files?: Array<{
            __typename?: 'PatientFile'
            fileID: string
            filename: string
            contentType: string
            downloadURL?: string | null
          }> | null
          linkedResponse?: {
            __typename?: 'PatientResponse'
            responseID: string
            lessonID: string
            title?: string | null
            category?: string | null
            createdAt: Date
          } | null
          linkedLesson?: {
            __typename?: 'ChatMessageLinkedLesson'
            lessonID: string
            title?: string | null
            category?: string | null
          } | null
        }
      | {
          __typename: 'LabOrderEvent'
          createdAt: Date
          orderID: string
          coachID?: string | null
          itemID: string
          orderStatus: Types.LabOrderStatus
          events: Array<{ __typename?: 'LabOrderSubEvent'; status: string; occuredAt: Date }>
        }
      | {
          __typename: 'OverdueQuestionnaire'
          itemID: string
          createdAt: Date
          questionnaireLessonID: string
          moduleNumber: number
        }
      | {
          __typename: 'PatientResponse'
          createdAt: Date
          title?: string | null
          lessonID: string
          category?: string | null
          duration?: number | null
          isCompleted: boolean
          programID: string
          itemID: string
          sections: Array<{
            __typename?: 'PatientResponseSection'
            sectionID: string
            title?: string | null
            type?: string | null
            entries: Array<{
              __typename?: 'PatientResponseSectionEntry'
              entryID: string
              question?: string | null
              rawValue?: Types.JSONValue | null
              tag?: string | null
              entryContext?: {
                __typename?: 'PatientResponseSectionEntryContextSingleChoice'
                options: Array<{
                  __typename?: 'PatientResponseSectionEntryContextSingleChoiceOption'
                  value: string
                  label: string
                }>
              } | null
            }>
          }>
        }
      | {
          __typename: 'ResumedPatientResponse'
          createdAt: Date
          itemID: string
          resumedResponse: {
            __typename?: 'PatientResponse'
            responseID: string
            title?: string | null
            lessonID: string
            category?: string | null
            duration?: number | null
            isCompleted: boolean
            programID: string
            sections: Array<{
              __typename?: 'PatientResponseSection'
              sectionID: string
              title?: string | null
              type?: string | null
              entries: Array<{
                __typename?: 'PatientResponseSectionEntry'
                entryID: string
                question?: string | null
                rawValue?: Types.JSONValue | null
                tag?: string | null
                entryContext?: {
                  __typename?: 'PatientResponseSectionEntryContextSingleChoice'
                  options: Array<{
                    __typename?: 'PatientResponseSectionEntryContextSingleChoiceOption'
                    value: string
                    label: string
                  }>
                } | null
              }>
            }>
          }
        }
      | {
          __typename: 'SmsMessage'
          twilioMessageID: string
          uid: string
          coachID?: string | null
          createdAt: Date
          status: Types.SmsMessageStatus
          text: string
          itemID: string
          smsMessageDirection: Types.SmsMessageDirection
        }
      | {
          __typename: 'VideoCall'
          createdAt: Date
          callType: Types.VideoCallType
          startTime: Date
          endTime: Date
          cancelledAt?: Date | null
          cancelledBy?: Types.VideoCallCancelledBy | null
          itemID: string
          coach: { __typename?: 'CoachProfile'; id: string }
        }
    >
  }
  patient: { __typename?: 'Patient'; uid: string; chatMessagingEnabled?: boolean | null }
}

export type GetAdvancedRoleChatMessagesQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  after?: Types.InputMaybe<Types.Scalars['DateTime']['input']>
  before?: Types.InputMaybe<Types.Scalars['DateTime']['input']>
}>

export type GetAdvancedRoleChatMessagesQuery = {
  __typename?: 'Query'
  advancedRoleChatMessages: Array<{
    __typename: 'ChatMessage'
    messageID: string
    feedID: string
    createdAt: Date
    text: string
    coachID?: string | null
    itemID: string
    chatMessageDirection: Types.ChatMessageDirection
    files?: Array<{
      __typename?: 'PatientFile'
      fileID: string
      filename: string
      contentType: string
      downloadURL?: string | null
    }> | null
    linkedResponse?: {
      __typename?: 'PatientResponse'
      responseID: string
      lessonID: string
      title?: string | null
      category?: string | null
      createdAt: Date
    } | null
    linkedLesson?: {
      __typename?: 'ChatMessageLinkedLesson'
      lessonID: string
      title?: string | null
      category?: string | null
    } | null
  }>
}

export type AdvancedPatientResponseItemFragment = {
  __typename?: 'PatientResponse'
  title?: string | null
  lessonID: string
  category?: string | null
  duration?: number | null
  isCompleted: boolean
  programID: string
  sections: Array<{
    __typename?: 'PatientResponseSection'
    sectionID: string
    title?: string | null
    type?: string | null
    entries: Array<{
      __typename?: 'PatientResponseSectionEntry'
      entryID: string
      question?: string | null
      rawValue?: Types.JSONValue | null
      tag?: string | null
      entryContext?: {
        __typename?: 'PatientResponseSectionEntryContextSingleChoice'
        options: Array<{
          __typename?: 'PatientResponseSectionEntryContextSingleChoiceOption'
          value: string
          label: string
        }>
      } | null
    }>
  }>
}

export type CreatePatientChatMessageMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  text: Types.Scalars['String']['input']
  linksTo?: Types.InputMaybe<Types.ChatMessageLinksToInput>
  fileIDs?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>
}>

export type CreatePatientChatMessageMutation = {
  __typename?: 'Mutation'
  createChatMessage: {
    __typename: 'ChatMessageCreated'
    chatMessage?: {
      __typename?: 'ChatMessage'
      messageID: string
      text: string
      createdAt: Date
      files?: Array<{
        __typename?: 'PatientFile'
        fileID: string
        filename: string
        contentType: string
        downloadURL?: string | null
      }> | null
    } | null
  }
}

export type CreatePatientRoleChatMessageMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  text: Types.Scalars['String']['input']
  linksTo?: Types.InputMaybe<Types.ChatMessageLinksToInput>
  fileIDs?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>
  role: Types.Scalars['String']['input']
}>

export type CreatePatientRoleChatMessageMutation = {
  __typename?: 'Mutation'
  createRoleChatMessage: {
    __typename: 'ChatMessageCreated'
    chatMessage?: {
      __typename?: 'ChatMessage'
      messageID: string
      text: string
      createdAt: Date
      files?: Array<{
        __typename?: 'PatientFile'
        fileID: string
        filename: string
        contentType: string
        downloadURL?: string | null
      }> | null
    } | null
  }
}

export type EditPatientChatMessageMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  messageIDHash: Types.Scalars['ID']['input']
  text: Types.Scalars['String']['input']
}>

export type EditPatientChatMessageMutation = {
  __typename?: 'Mutation'
  editChatMessage: {
    __typename: 'ChatMessageEdited'
    chatMessage: { __typename?: 'ChatMessage'; messageID: string; text: string; createdAt: Date }
  }
}

export type MarkPatientFeedSeenMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type MarkPatientFeedSeenMutation = {
  __typename?: 'Mutation'
  markFeedSeen: {
    __typename?: 'FeedSeenResult'
    patient: {
      __typename: 'Patient'
      uid: string
      indicators?: {
        __typename?: 'PatientIndicators'
        lastViewedAt?: Date | null
        newMessages?: { __typename?: 'PatientNewMessageIndicator'; count: number } | null
        advancedRoleChatNewMessages?: { __typename?: 'PatientNewMessageIndicator'; count: number } | null
      } | null
    }
  }
}

export type MarkPatientFeedUnreadFromMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  from: Types.Scalars['DateTime']['input']
}>

export type MarkPatientFeedUnreadFromMutation = {
  __typename?: 'Mutation'
  markFeedUnreadFrom: {
    __typename?: 'FeedSeenResult'
    seenAt: Date
    patient: {
      __typename: 'Patient'
      uid: string
      indicators?: {
        __typename?: 'PatientIndicators'
        lastViewedAt?: Date | null
        newMessages?: { __typename?: 'PatientNewMessageIndicator'; count: number } | null
        advancedRoleChatNewMessages?: { __typename?: 'PatientNewMessageIndicator'; count: number } | null
      } | null
    }
  }
}

export const AdvancedPatientResponseItemFragmentDoc = gql`
  fragment advancedPatientResponseItem on PatientResponse {
    title
    lessonID
    category
    duration
    isCompleted
    programID
    sections(groupSections: true) {
      sectionID
      title
      type
      entries {
        entryID
        question
        rawValue
        tag
        entryContext {
          ... on PatientResponseSectionEntryContextSingleChoice {
            options {
              value
              label
            }
          }
        }
      }
    }
  }
`
export const GetPatientConversationDocument = gql`
  query getPatientConversation($uid: ID!, $limit: Int, $order: FeedOrder, $before: DateTime, $after: DateTime) {
    feed(uid: $uid, limit: $limit, order: $order, before: $before, after: $after) {
      ... on FeedSuccess {
        items {
          __typename
          ... on ChatMessage {
            itemID: messageID
            messageID
            feedID
            createdAt
            text
            coachID
            chatMessageDirection: direction
            files {
              fileID
              filename
              contentType
              downloadURL
            }
            linkedResponse {
              responseID
              lessonID
              title
              category
              createdAt
            }
            linkedLesson {
              lessonID
              title
              category
            }
          }
          ... on SmsMessage {
            itemID: twilioMessageID
            twilioMessageID
            uid
            coachID
            createdAt
            smsMessageDirection: direction
            status
            text
          }
          ... on PatientResponse {
            itemID: responseID
            createdAt
            ...advancedPatientResponseItem
          }
          ... on ResumedPatientResponse {
            itemID: id
            createdAt
            resumedResponse {
              responseID
              ...advancedPatientResponseItem
            }
          }
          ... on VideoCall {
            itemID: id
            createdAt
            callType
            startTime
            endTime
            cancelledAt
            cancelledBy
            coach {
              id
            }
          }
          ... on LabOrderEvent {
            itemID: eventID
            createdAt
            orderID
            orderStatus: status
            coachID
            events {
              status
              occuredAt
            }
          }
          ... on OverdueQuestionnaire {
            itemID
            createdAt
            questionnaireLessonID: lessonID
            moduleNumber: weekNbr
          }
        }
        lastSeenAt
      }
    }
    patient(uid: $uid) {
      uid
      chatMessagingEnabled
    }
  }
  ${AdvancedPatientResponseItemFragmentDoc}
`

/**
 * __useGetPatientConversationQuery__
 *
 * To run a query within a React component, call `useGetPatientConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientConversationQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPatientConversationQuery(
  baseOptions: Apollo.QueryHookOptions<GetPatientConversationQuery, GetPatientConversationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPatientConversationQuery, GetPatientConversationQueryVariables>(
    GetPatientConversationDocument,
    options
  )
}
export function useGetPatientConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPatientConversationQuery, GetPatientConversationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPatientConversationQuery, GetPatientConversationQueryVariables>(
    GetPatientConversationDocument,
    options
  )
}
export type GetPatientConversationQueryHookResult = ReturnType<typeof useGetPatientConversationQuery>
export type GetPatientConversationLazyQueryHookResult = ReturnType<typeof useGetPatientConversationLazyQuery>
export type GetPatientConversationQueryResult = Apollo.QueryResult<
  GetPatientConversationQuery,
  GetPatientConversationQueryVariables
>
export const GetAdvancedRoleChatMessagesDocument = gql`
  query getAdvancedRoleChatMessages($uid: ID!, $after: DateTime, $before: DateTime) {
    advancedRoleChatMessages(uid: $uid, order: ASC, after: $after, before: $before) {
      __typename
      itemID: messageID
      messageID
      feedID
      createdAt
      text
      coachID
      chatMessageDirection: direction
      files {
        fileID
        filename
        contentType
        downloadURL
      }
      linkedResponse {
        responseID
        lessonID
        title
        category
        createdAt
      }
      linkedLesson {
        lessonID
        title
        category
      }
    }
  }
`

/**
 * __useGetAdvancedRoleChatMessagesQuery__
 *
 * To run a query within a React component, call `useGetAdvancedRoleChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedRoleChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedRoleChatMessagesQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetAdvancedRoleChatMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<GetAdvancedRoleChatMessagesQuery, GetAdvancedRoleChatMessagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedRoleChatMessagesQuery, GetAdvancedRoleChatMessagesQueryVariables>(
    GetAdvancedRoleChatMessagesDocument,
    options
  )
}
export function useGetAdvancedRoleChatMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAdvancedRoleChatMessagesQuery, GetAdvancedRoleChatMessagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedRoleChatMessagesQuery, GetAdvancedRoleChatMessagesQueryVariables>(
    GetAdvancedRoleChatMessagesDocument,
    options
  )
}
export type GetAdvancedRoleChatMessagesQueryHookResult = ReturnType<typeof useGetAdvancedRoleChatMessagesQuery>
export type GetAdvancedRoleChatMessagesLazyQueryHookResult = ReturnType<typeof useGetAdvancedRoleChatMessagesLazyQuery>
export type GetAdvancedRoleChatMessagesQueryResult = Apollo.QueryResult<
  GetAdvancedRoleChatMessagesQuery,
  GetAdvancedRoleChatMessagesQueryVariables
>
export const CreatePatientChatMessageDocument = gql`
  mutation createPatientChatMessage($uid: ID!, $text: String!, $linksTo: ChatMessageLinksToInput, $fileIDs: [ID!]) {
    createChatMessage(uid: $uid, text: $text, linksTo: $linksTo, fileIDs: $fileIDs) {
      __typename
      ... on ChatMessageCreated {
        chatMessage {
          messageID
          text
          createdAt
          files {
            fileID
            filename
            contentType
            downloadURL
          }
        }
      }
    }
  }
`
export type CreatePatientChatMessageMutationFn = Apollo.MutationFunction<
  CreatePatientChatMessageMutation,
  CreatePatientChatMessageMutationVariables
>

/**
 * __useCreatePatientChatMessageMutation__
 *
 * To run a mutation, you first call `useCreatePatientChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientChatMessageMutation, { data, loading, error }] = useCreatePatientChatMessageMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      text: // value for 'text'
 *      linksTo: // value for 'linksTo'
 *      fileIDs: // value for 'fileIDs'
 *   },
 * });
 */
export function useCreatePatientChatMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePatientChatMessageMutation, CreatePatientChatMessageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreatePatientChatMessageMutation, CreatePatientChatMessageMutationVariables>(
    CreatePatientChatMessageDocument,
    options
  )
}
export type CreatePatientChatMessageMutationHookResult = ReturnType<typeof useCreatePatientChatMessageMutation>
export type CreatePatientChatMessageMutationResult = Apollo.MutationResult<CreatePatientChatMessageMutation>
export type CreatePatientChatMessageMutationOptions = Apollo.BaseMutationOptions<
  CreatePatientChatMessageMutation,
  CreatePatientChatMessageMutationVariables
>
export const CreatePatientRoleChatMessageDocument = gql`
  mutation createPatientRoleChatMessage(
    $uid: ID!
    $text: String!
    $linksTo: ChatMessageLinksToInput
    $fileIDs: [ID!]
    $role: String!
  ) {
    createRoleChatMessage(uid: $uid, text: $text, linksTo: $linksTo, fileIDs: $fileIDs, role: $role) {
      __typename
      ... on ChatMessageCreated {
        chatMessage {
          messageID
          text
          createdAt
          files {
            fileID
            filename
            contentType
            downloadURL
          }
        }
      }
    }
  }
`
export type CreatePatientRoleChatMessageMutationFn = Apollo.MutationFunction<
  CreatePatientRoleChatMessageMutation,
  CreatePatientRoleChatMessageMutationVariables
>

/**
 * __useCreatePatientRoleChatMessageMutation__
 *
 * To run a mutation, you first call `useCreatePatientRoleChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientRoleChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientRoleChatMessageMutation, { data, loading, error }] = useCreatePatientRoleChatMessageMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      text: // value for 'text'
 *      linksTo: // value for 'linksTo'
 *      fileIDs: // value for 'fileIDs'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useCreatePatientRoleChatMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePatientRoleChatMessageMutation,
    CreatePatientRoleChatMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreatePatientRoleChatMessageMutation, CreatePatientRoleChatMessageMutationVariables>(
    CreatePatientRoleChatMessageDocument,
    options
  )
}
export type CreatePatientRoleChatMessageMutationHookResult = ReturnType<typeof useCreatePatientRoleChatMessageMutation>
export type CreatePatientRoleChatMessageMutationResult = Apollo.MutationResult<CreatePatientRoleChatMessageMutation>
export type CreatePatientRoleChatMessageMutationOptions = Apollo.BaseMutationOptions<
  CreatePatientRoleChatMessageMutation,
  CreatePatientRoleChatMessageMutationVariables
>
export const EditPatientChatMessageDocument = gql`
  mutation editPatientChatMessage($uid: ID!, $messageIDHash: ID!, $text: String!) {
    editChatMessage(uid: $uid, messageIDHash: $messageIDHash, text: $text) {
      __typename
      ... on ChatMessageEdited {
        chatMessage {
          messageID
          text
          createdAt
        }
      }
    }
  }
`
export type EditPatientChatMessageMutationFn = Apollo.MutationFunction<
  EditPatientChatMessageMutation,
  EditPatientChatMessageMutationVariables
>

/**
 * __useEditPatientChatMessageMutation__
 *
 * To run a mutation, you first call `useEditPatientChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPatientChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPatientChatMessageMutation, { data, loading, error }] = useEditPatientChatMessageMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      messageIDHash: // value for 'messageIDHash'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useEditPatientChatMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<EditPatientChatMessageMutation, EditPatientChatMessageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditPatientChatMessageMutation, EditPatientChatMessageMutationVariables>(
    EditPatientChatMessageDocument,
    options
  )
}
export type EditPatientChatMessageMutationHookResult = ReturnType<typeof useEditPatientChatMessageMutation>
export type EditPatientChatMessageMutationResult = Apollo.MutationResult<EditPatientChatMessageMutation>
export type EditPatientChatMessageMutationOptions = Apollo.BaseMutationOptions<
  EditPatientChatMessageMutation,
  EditPatientChatMessageMutationVariables
>
export const MarkPatientFeedSeenDocument = gql`
  mutation markPatientFeedSeen($uid: ID!) {
    markFeedSeen(uid: $uid) {
      patient {
        __typename
        uid
        indicators {
          lastViewedAt
          newMessages {
            count
          }
          advancedRoleChatNewMessages {
            count
          }
        }
      }
    }
  }
`
export type MarkPatientFeedSeenMutationFn = Apollo.MutationFunction<
  MarkPatientFeedSeenMutation,
  MarkPatientFeedSeenMutationVariables
>

/**
 * __useMarkPatientFeedSeenMutation__
 *
 * To run a mutation, you first call `useMarkPatientFeedSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPatientFeedSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPatientFeedSeenMutation, { data, loading, error }] = useMarkPatientFeedSeenMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useMarkPatientFeedSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<MarkPatientFeedSeenMutation, MarkPatientFeedSeenMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MarkPatientFeedSeenMutation, MarkPatientFeedSeenMutationVariables>(
    MarkPatientFeedSeenDocument,
    options
  )
}
export type MarkPatientFeedSeenMutationHookResult = ReturnType<typeof useMarkPatientFeedSeenMutation>
export type MarkPatientFeedSeenMutationResult = Apollo.MutationResult<MarkPatientFeedSeenMutation>
export type MarkPatientFeedSeenMutationOptions = Apollo.BaseMutationOptions<
  MarkPatientFeedSeenMutation,
  MarkPatientFeedSeenMutationVariables
>
export const MarkPatientFeedUnreadFromDocument = gql`
  mutation markPatientFeedUnreadFrom($uid: ID!, $from: DateTime!) {
    markFeedUnreadFrom(uid: $uid, from: $from) {
      seenAt
      patient {
        __typename
        uid
        indicators {
          lastViewedAt
          newMessages {
            count
          }
          advancedRoleChatNewMessages {
            count
          }
        }
      }
    }
  }
`
export type MarkPatientFeedUnreadFromMutationFn = Apollo.MutationFunction<
  MarkPatientFeedUnreadFromMutation,
  MarkPatientFeedUnreadFromMutationVariables
>

/**
 * __useMarkPatientFeedUnreadFromMutation__
 *
 * To run a mutation, you first call `useMarkPatientFeedUnreadFromMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPatientFeedUnreadFromMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPatientFeedUnreadFromMutation, { data, loading, error }] = useMarkPatientFeedUnreadFromMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useMarkPatientFeedUnreadFromMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkPatientFeedUnreadFromMutation,
    MarkPatientFeedUnreadFromMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MarkPatientFeedUnreadFromMutation, MarkPatientFeedUnreadFromMutationVariables>(
    MarkPatientFeedUnreadFromDocument,
    options
  )
}
export type MarkPatientFeedUnreadFromMutationHookResult = ReturnType<typeof useMarkPatientFeedUnreadFromMutation>
export type MarkPatientFeedUnreadFromMutationResult = Apollo.MutationResult<MarkPatientFeedUnreadFromMutation>
export type MarkPatientFeedUnreadFromMutationOptions = Apollo.BaseMutationOptions<
  MarkPatientFeedUnreadFromMutation,
  MarkPatientFeedUnreadFromMutationVariables
>
